'use strict';

const PREFIX = '+52 ';
const FIRST_DASH_POSITION = 2;
const SECOND_DASH_POSITION = 7;

function removePrefixFromPhone(phone) {
    if (!phone || typeof phone !== 'string') {
        return '';
    }

    if (phone.includes(PREFIX)) {
        return phone.replace(PREFIX, '');
    }

    return phone;
}

function formatPhoneNumber(displayValue) {
    let formattedValue = displayValue;
    if (displayValue.length > FIRST_DASH_POSITION) {
        formattedValue = displayValue.slice(0, FIRST_DASH_POSITION) + '-' + displayValue.slice(FIRST_DASH_POSITION);
    }
    if (displayValue.length > SECOND_DASH_POSITION) {
        formattedValue = formattedValue.slice(0, SECOND_DASH_POSITION) + '-' + formattedValue.slice(SECOND_DASH_POSITION, 11);
    }
    return formattedValue;
}

function getFormattedValueFromString(inputValue) {
    if (!inputValue || typeof inputValue !== 'string') {
        return '';
    }

    inputValue = removePrefixFromPhone(inputValue);
    const displayValue = inputValue.replace(/\D/g, '');
    const formattedValue = formatPhoneNumber(displayValue);

    return formattedValue ? PREFIX + formattedValue : '';
}

function getFormattedValue(element) {
    let inputValue = element.is('input') ? element.val() : element.text();
    inputValue = removePrefixFromPhone(inputValue);
    const displayValue = inputValue.replace(/\D/g, '');
    const formattedValue = formatPhoneNumber(displayValue);

    return formattedValue ? PREFIX + formattedValue : '';
}


/**
 * Updates the display value of phone input while maintaining clean value
 */
function handleControlPhoneInput() {
    const $input = $(this);
    const $hiddenInput = $input.siblings('input[type="hidden"]');
    let inputValue = $input.val();
    inputValue = removePrefixFromPhone(inputValue);
    const rawValue = inputValue.replace(/\D/g, '');

    if(rawValue.length < 11 && rawValue.length > 2){
        $hiddenInput.val(rawValue);
    }
    const formattedValue = getFormattedValue($input);

    $input.val(formattedValue).attr('data-display', formattedValue);
}

/**
 * Initialize phone input control
 */
function initControlledPhoneInput() {
    // Create hidden inputs for each phone input
    $('input[type="tel"].form-control').each(function() {
        const name = $(this).attr('name');

        if (!name.endsWith('Display')) {
            $(this).attr('name', name + 'Display').after(`<input type="hidden" name="${name}" />`);
        }

        const initialValue = $(this).val();
        if (initialValue) {
            handleControlPhoneInput.call(this);
        }
    });

    $(document).on('input change', 'input[type="tel"].form-control', function() {
        handleControlPhoneInput.call(this);
    });

    $(document).on('formatPhoneInputValue', function(e, $input) {
        handleControlPhoneInput.call($input);
    });

    $('.phone-format').each(function() {
        const $element = $(this);
        const formattedValue = getFormattedValue($element);
        $element.text(formattedValue);
    });
}

module.exports = {
    initControlledPhoneInput,
    getFormattedValueFromString
};
